import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { Button } from '@common/components';
import { PERFORM_OFFER_ACTION_MUTATION } from '@applicant-flow/graphql';

export function AcceptOfferAction({ offerId, disabled, onClose = () => {} }) {
  const [loading, setLoading] = useState(false);

  const [performAction] = useMutation(PERFORM_OFFER_ACTION_MUTATION, {
    onCompleted() {
      createMessage('success', 'Offer successfully accepted!');
      onClose();
    },
    onError: () => {
      setLoading(false);
      createMessage(
        'error',
        'Failed to update Offer state. Please try again or contact your hiring partner.'
      );
    },
  });

  const onClick = () => {
    setLoading(true);
    performAction({
      variables: {
        offerId: offerId,
        input: {
          action: 'accept',
        },
      },
    });
  };

  return (
    <Button
      kind="primary"
      loading={loading}
      disabled={disabled}
      onClick={onClick}
    >
      Accept Offer
    </Button>
  );
}

AcceptOfferAction.propTypes = {
  offerId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onClose: PropTypes.func,
};
